(() => {
  'use strict';
  const core = window.ConcordPreorderCore;
  if (!core) return;
  const controllers = new WeakMap();
  const liveControllers = new Set();
  let dialog, pending;

  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'concord-restock-dialog';
    dialog.setAttribute('aria-labelledby', 'concord-restock-title');
    dialog.setAttribute('aria-describedby', 'concord-restock-summary');
    dialog.innerHTML = '<h2 id="concord-restock-title">Restock preorder</h2><p id="concord-restock-summary"></p><label class="concord-restock-check"><input type="checkbox" data-restock-checkbox><span data-restock-checkbox-text></span></label><div class="concord-restock-actions"><button type="button" class="btn concord-restock-cancel" data-restock-cancel>Cancel</button><button type="button" class="btn" data-restock-continue disabled>Continue</button></div>';
    document.body.appendChild(dialog);
    const checkbox = dialog.querySelector('[data-restock-checkbox]');
    const proceed = dialog.querySelector('[data-restock-continue]');
    checkbox.addEventListener('change', () => { proceed.disabled = !checkbox.checked; });
    dialog.querySelector('[data-restock-cancel]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { if (dialog.open) return; const old = pending; pending = null; old?.submitter?.focus(); });
    proceed.addEventListener('click', () => {
      if (!checkbox.checked || !pending) return;
      const saved = pending;
      saved.controller.update();
      const state = saved.controller.state;
      if (!state || !state.available) { dialog.close(); return; }
      if (!state.restockActive || saved.signature !== `${state.id}|${state.shipDay}`) {
        dialog.close();
        if (state.restockActive) showAcknowledgement(saved.controller, saved.submitter);
        else saved.controller.form.requestSubmit(saved.submitter);
        return;
      }
      saved.controller.approvedOnce = saved.signature;
      const ack = saved.controller.form.querySelector('[data-concord-ack]');
      ack.value = state.shipDay;
      ack.disabled = false;
      dialog.close();
      saved.controller.form.requestSubmit(saved.submitter);
    });
    return dialog;
  }

  function showAcknowledgement(controller, submitter) {
    const popup = getDialog();
    if (popup.open) popup.close();
    const state = controller.state;
    popup.querySelector('[data-restock-checkbox]').checked = false;
    popup.querySelector('[data-restock-continue]').disabled = true;
    popup.querySelector('#concord-restock-summary').textContent = `The initial pressing is sold out. A 2nd pressing is underway with an expected ship date of ${state.shipDate}. Orders with multiple items ship when all are in stock. For faster delivery, consider ordering separately.`;
    popup.querySelector('[data-restock-checkbox-text]').textContent = `I understand this product is expected to ship on ${state.shipDate}.`;
    pending = { controller, submitter, signature: `${state.id}|${state.shipDay}` };
    popup.showModal();
  }

  class Controller {
    constructor(form, data) {
      this.form = form;
      this.data = data;
      this.scope = form.closest('.product-section') || form.parentElement;
      this.lastSignature = null;
      form.addEventListener('change', () => queueMicrotask(() => this.update()));
      this.update();
    }

    handleSubmit(event) {
      this.update();
      if (!this.state?.available) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (!this.state.restockActive) return;
      const signature = `${this.state.id}|${this.state.shipDay}`;
      if (this.approvedOnce === signature) { this.approvedOnce = null; return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      showAcknowledgement(this, event.submitter || this.form.querySelector('[data-add-to-cart]'));
    }

    update() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.data.variants.find(item => String(item.id) === String(id));
      const text = this.form.querySelector('[data-add-to-cart-text]');
      const button = this.form.querySelector('[data-add-to-cart]');
      if (!variant) {
        this.state = null;
        this.lastSignature = null;
        this.approvedOnce = null;
        if (pending?.controller === this && dialog?.open) dialog.close();
        for (const field of this.form.querySelectorAll('[data-concord-ship-public], [data-concord-ship-private], [data-concord-ack]')) { field.disabled = true; field.value = ''; }
        this.scope.querySelectorAll('[data-concord-release-date], [data-concord-restock-date], [data-concord-notice]').forEach(node => { node.hidden = true; });
        if (button) button.disabled = true;
        if (text) text.textContent = this.data.strings.unavailable;
        return;
      }
      try { this.state = core.variantState(variant, core.storeDay(new Date(), this.data.timeZone), this.data.timeZone); }
      catch (error) {
        console.error('Preorder dates could not be read', error);
        if (button) button.disabled = true;
        this.state = null;
        for (const field of this.form.querySelectorAll('[data-concord-ship-public], [data-concord-ship-private], [data-concord-ack]')) { field.disabled = true; field.value = ''; }
        return;
      }
      const state = this.state;
      const signature = `${state.id}|${state.shipDay}|${state.restockActive}`;
      if (signature !== this.lastSignature) {
        this.lastSignature = signature;
        this.approvedOnce = null;
        const ack = this.form.querySelector('[data-concord-ack]');
        ack.value = '';
        ack.disabled = true;
        if (pending?.controller === this && dialog?.open) dialog.close();
      }
      const setField = (selector, value) => {
        const field = this.form.querySelector(selector);
        field.value = value || '';
        field.disabled = !state.isPreorder;
      };
      setField('[data-concord-ship-public]', state.shipDate);
      setField('[data-concord-ship-private]', state.shipDay);
      const label = state.available ? state.isPreorder ? this.data.strings.preorder : this.data.strings.addToCart : this.data.strings.soldOut;
      if (text) { text.textContent = label; text.dataset.defaultText = label; }
      if (button) { button.disabled = !state.available; button.classList.toggle('disabled', !state.available); }
      const dynamic = this.form.querySelector('.shopify-payment-button');
      if (dynamic) { dynamic.hidden = state.restockActive; dynamic.style.display = state.restockActive ? 'none' : ''; }
      const release = this.scope.querySelector('[data-concord-release-date]');
      if (release) { release.hidden = !state.releaseDay; release.innerHTML = state.releaseDay ? `<strong>Release Date: ${core.escapeHtml(state.releaseFormatted)}</strong><br>` : ''; }
      const restock = this.scope.querySelector('[data-concord-restock-date]');
      if (restock) { restock.hidden = !state.restockActive; restock.innerHTML = state.restockActive ? `<strong>Restock Release Date: ${core.escapeHtml(state.shipDate)}</strong><br>` : ''; }
      const notice = this.scope.querySelector('[data-concord-notice]');
      if (notice) { notice.hidden = !state.isPreorder; const html = core.noticeHtml(state); if (notice.innerHTML.trim() !== html.trim()) notice.innerHTML = html; }
      const sales = this.scope.querySelector('.sales-points');
      if (sales) sales.style.display = state.isPreorder ? 'none' : '';
      this.scope.querySelectorAll('[data-concord-description]').forEach(description => {
        if (description.dataset.concordCleaned) return;
        description.innerHTML = core.stripManagedNotices(description.innerHTML);
        description.dataset.concordCleaned = 'true';
      });
    }
  }

  function scan() {
    document.querySelectorAll('form [data-concord-preorder-data]').forEach(script => {
      const form = script.closest('form');
      if (controllers.has(form)) return;
      try { const controller = new Controller(form, JSON.parse(script.textContent)); controllers.set(form, controller); liveControllers.add(controller); }
      catch (error) { console.error('Preorder form could not be initialized', error); const button = form.querySelector('[data-add-to-cart]'); if (button) button.disabled = true; }
    });
    for (const controller of liveControllers) { if (!controller.form.isConnected) liveControllers.delete(controller); }
  }
  document.addEventListener('variant:change', () => queueMicrotask(() => { for (const controller of liveControllers) controller.update(); }));
  // Run before app/document click handlers so restock consent precedes upsells.
  window.addEventListener('click', event => {
    const button = event.target.closest?.('[data-add-to-cart]');
    if (!button) return;
    const form = button.closest('form');
    if (!controllers.has(form)) scan();
    const controller = controllers.get(form);
    if (!controller) return;
    controller.update();
    if (!controller.state?.restockActive) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (controller.state.available) showAcknowledgement(controller, button);
  }, true);
  window.addEventListener('submit', event => {
    if (!controllers.has(event.target)) scan();
    controllers.get(event.target)?.handleSubmit(event);
  }, true);
  document.addEventListener('quickview:loaded', scan);
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('form') || node.querySelector?.('[data-concord-preorder-data]'))))) scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(() => { for (const controller of liveControllers) controller.update(); }, 30000);
  scan();
})();
